import { useAuthStore } from "@/stores/AuthStore";
import { storeToRefs } from "pinia";

export function usePermissions() {
  const authStore = useAuthStore();

  const { isAdmin, isAluno, isOrientador, isUserNormal } =
    storeToRefs(authStore);

  /**
   * Verifica se o usuário autenticado possui uma permissão específica.
   * @param permissionName O nome da permissão a ser verificada (ex: 'trabalho.delete').
   */
  const can = (permissionName: string): boolean => {
    return authStore.hasPermission(permissionName);
  };

  /**
   * Verifica múltiplas permissões (OR logic)
   */
  const canAny = (permissions: string[]): boolean => {
    return permissions.some((permission) =>
      authStore.hasPermission(permission)
    );
  };

  /**
   * Verifica múltiplas permissões (AND logic)
   */
  const canAll = (permissions: string[]): boolean => {
    return permissions.every((permission) =>
      authStore.hasPermission(permission)
    );
  };

  const canViewTrabalhos = () => authStore.canViewTrabalhos();
  const canCreateTrabalhos = () => authStore.canCreateTrabalho();
  const canUpdateTrabalhos = () => authStore.canUpdateTrabalho();
  const canDeleteTrabalhos = () => authStore.canDeleteTrabalho();

  const canViewCorrecoes = () => authStore.canViewCorrecoes();
  const canCreateCorrecoes = () => authStore.canCreateCorrecao();
  const canResolveCorrecoes = () => authStore.canResolveCorrecao();

  return {
    can,
    canAny,
    canAll,
    isAdmin,
    isAluno,
    isOrientador,
    isUserNormal,
    canViewTrabalhos,
    canCreateTrabalhos,
    canUpdateTrabalhos,
    canDeleteTrabalhos,
    canViewCorrecoes,
    canCreateCorrecoes,
    canResolveCorrecoes,
  };
}
